import 'promise-polyfill';
import 'url-polyfill';
import { GlobalMessage } from './GlobalMessage';
import { GlobalMessageHandler } from './GlobalMessageHandler';
import { LazyLoader } from './LazyLoader';
import { ModalManager } from './ModalManager';
import { Page } from './Page';
import { PageStart } from './PageStart';
import { Utilities } from './Utilities';
// Define all classes which should be exposed to the global
// scope for picker, widgets and additional scripts
window.LazyLoader = LazyLoader;
window.GlobalMessage = GlobalMessage;
window.GlobalMessageHandler = GlobalMessageHandler;
window.Utilities = Utilities;
let pageAlreadyLoaded = false;
document.addEventListener('page_hydrated', () => (pageAlreadyLoaded = true));
const dsOnPageReady = (cb) => {
    if (pageAlreadyLoaded) {
        cb();
    }
    else {
        document.addEventListener('page_hydrated', cb);
    }
};
//window.tippy = tippy;
const tippyQueue = [];
let tippyLoaded = false;
const tippy = (window.tippy = (...args) => {
    const loadTippy = async () => {
        const tippy = await import(/* webpackChunkName: "tippy" */ 'tippy.js');
        window.tippy = tippy;
        tippyQueue.forEach(q => {
            q.resolve(tippy.default.apply(null, q.args));
        });
    };
    const promise = new Promise(resolve => {
        tippyQueue.push({ resolve, args });
    });
    if (!tippyLoaded) {
        tippyLoaded = true;
        loadTippy();
    }
    return {
        setContent: async (...cargs) => {
            const instance = await promise;
            instance.setContent(...cargs);
        },
    };
});
new PageStart();
document.addEventListener('DOMContentLoaded', async () => {
    if ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
        // Minimal polyfill for Edge 15's lack of `isIntersecting`
        // See: https://github.com/w3c/IntersectionObserver/issues/211
        if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
            Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
                get: function () {
                    return this.intersectionRatio > 0;
                },
            });
        }
    }
    else {
        await import(
        /* webpackChunkName: "intersection-observer" */
        'intersection-observer');
    }
    new LazyLoader();
    const tippySelector = '[data-tippy-content]';
    if (document.querySelectorAll(tippySelector)) {
        tippy(tippySelector, {
            arrow: true,
            placement: 'top',
            theme: 'pgb-tips',
        });
    }
    window.dispatchEvent(new Event('page_ready'));
    if (!('scrollBehavior' in document.documentElement.style)) {
        await import(
        /* webpackChunkName: "scroll-behavior-polyfill" */
        'scroll-behavior-polyfill');
    }
    dsOnPageReady(() => {
        window.PageInstance = new Page();
        window.modalManager = new ModalManager();
    });
});
